import { motion } from 'framer-motion';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        padding-top: 0;
    }

    backdrop-filter: blur(2px);
`;

export const ModalWrapper = styled.div`
    max-width: 30rem;
    width: 100%;

    overflow-y: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10001;
    border-radius: 1.25rem;
    padding: 1.5rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
        font-weight: 600;
        padding-bottom: 1rem;
        font-size: 1.25rem;
    }

    @media (max-width: 1400px) {
        max-width: 40rem;
    }

    @media (max-width: 768px) {
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
    }
`;

export const ModalContent = styled.div`
    color: ${({ theme }) => theme.colors['neutral-900']};

    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    gap: 1.5rem;

    div {
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
    }

    h3 {
        color: var(--Neutral-900, #18181B);
        text-align: center;
        font-family: 'Inter', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }

    p {
        color: var(--Neutral-500, #71717A);
        text-align: center;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 19.6px;
    }

    .icon-circle-check {
        width: 128px !important;
        height: 128px !important;
    }

    a {
        color: var(--Neutral-900, #18181B);
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22.4px;
        text-decoration: none;
    }

    .btn-view-tickets {
        display: flex;
        padding: 0.75rem 1.5rem;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        border-radius: 0.75rem;
        background: var(--Supernova-500, #FFCF00);
    }
`;